import { AuxButton } from "@blk/aladdin-react-components-es";
import { AuxButtonSizeEnum, AuxButtonTypeEnum } from "@blk/aladdin-web-components";
import { saveAs } from "file-saver";
import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { requestAsync } from "redux-query";
import { getDownloadFileConfig } from "../cashflow-forecast/ins-cashflow-requests-config";
import { downloadEmptyTemplate } from "api/admin/src";
import { language } from "language/default";
export const InsDownloadEmptyTemplate = (props) => {
    const dispatch = useDispatch();
    const [requestedTemplate, setRequestedTemplate] = useState(false);
    const template = useSelector((s) => s.entities?.EmptyTemplate?.[props.templateType.toString()]);
    useEffect(() => {
        if (requestedTemplate && template) {
            saveAs(template, props.fileName);
            setRequestedTemplate(false);
        }
    }, [template, requestedTemplate, props.fileName]);
    return React.createElement(React.Fragment, null,
        React.createElement("span", null, language.en.skeleton.navigation.administration.whatToUpload),
        React.createElement(AuxButton, { icon: "download", size: AuxButtonSizeEnum.SMALL, label: language.en.skeleton.navigation.administration.downloadTemplate, type: AuxButtonTypeEnum.SECONDARY, onClick: () => {
                setRequestedTemplate(true);
                dispatch(requestAsync(getDownloadFileConfig({ id: props.templateType }, "EmptyTemplate", downloadEmptyTemplate)));
            } }));
};
